var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJsaConfirmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1749624,6.62653488 L20.1749624,6.87503129 L14.924975,6.87503129 L14.924975,1.62504381 L15.1734714,1.62504381 C15.4345448,1.62504381 15.6849638,1.72878425 15.8695738,1.91335413 L19.8866521,5.93043249 C20.0457876,6.08960798 20.1749624,6.40143013 20.1749624,6.62653488 Z M14.5968507,8.18752816 L20.1749624,8.18752816 L20.1749624,21.6406211 C20.1749624,22.1842771 19.7342458,22.6249937 19.1905898,22.6249937 L5.40937265,22.6249937 C4.86571665,22.6249937 4.425,22.1842771 4.425,21.6406211 L4.425,2.60941646 C4.425,2.06576046 4.86571665,1.62504381 5.40937265,1.62504381 L13.6124781,1.62504381 L13.6124781,7.20315551 C13.6124781,7.74456848 14.0554378,8.18752816 14.5968507,8.18752816 Z M17.2749964,12.6882613 L16.1196323,11.5234844 C15.9282132,11.3305032 15.6165913,11.3292214 15.42361,11.5206806 L11.0744421,15.8348812 L9.18852891,13.9337074 C8.99710977,13.7407261 8.68544783,13.7394845 8.49246657,13.9309437 L7.3277698,15.0863479 C7.13478854,15.277767 7.1335068,15.5893889 7.324966,15.7823701 L10.7128726,19.1977139 C10.9042917,19.3906551 11.2159537,19.3919368 11.4089349,19.2004776 L17.2721927,13.3842836 C17.4651739,13.1928644 17.4664556,12.8812025 17.2749964,12.6882613 Z",
    id: "path-1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsaConfirmed);
export default __webpack_public_path__ + "static/media/jsa-confirmed.fb39bd71.svg";
export { ForwardRef as ReactComponent };